// src/hooks/useWakeUp.js
import { useEffect } from 'react';

export default function useWakeUp() {
const API_URL = import.meta.env.VITE_API_URL;
  useEffect(() => {
    fetch(`${API_URL}/api/ping`, {
      method: 'GET',
      cache: 'no-store',
    })
  }, [API_URL]);
}
